<h2 class="textCenter mn-top f-31"> Tu solicitud de {{ title }} ha sido radicada {{ type }}. </h2>
<br>
<br>
<br>

<div class="p-circle">
    <div class="circle-blue ">
        <em class="material-icons" [ngClass]="{
              'color-red': !status,
              'color-green': status
            }"> {{icon}} </em>
    </div>
</div>

<div class="container-card mn-top" >
    <span class="font-16 color-blue-dark tac widdth80 textCenter" *ngIf="data?.response">
    	<div class="flex topPad botPad">
            <ng-container *ngFor="let item of data.response; let i = index">
                <p *ngIf="item.description!=''" class="grayTextColumn2 blue">{{item.code}} {{item.code!=''?'-':''}} {{item.description}}</p>
                <ng-container *ngIf="item.description==''"><br></ng-container>
            </ng-container>
        </div>
	</span>
</div>

<div *ngIf="radicado" class="container-card-blue color-white mn-top">
    <span class="f-30">{{ radicado | uppercase }}</span>
    <br>
    <span>Número de radicado</span>
</div>


<div class="textCenter mn-top">
    <button type="button" #btnconsult tabindex="0" id="btn-consult" class="btn-consult" [routerLink]="'/'+home">Volver al inicio </button>
</div>
